import React, { Component } from 'react';
import { Grid, Typography, FormControlLabel, Switch, TextField, Modal, Button, Paper } from '@material-ui/core';

//msgs
import { msgAction, msgSimple } from '../../../actions/snackbarActions';
import { connect } from 'react-redux';


class ModalAircraftType extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: '',
            type: {
                id: 'new',
                active: true,
                type: '',
            }
        }
    }

    onRender = () => {
        if (this.props.modal.id !== 'new') {
            this.setState({ type: this.props.modal })
        } else {
            this.setState({
                type:{
                id: 'new',
                active: true,
                type: '',
            }
            })
        }
    }


    render() {
        return (
            <Modal
                open={this.props.openModal}
                onRendered={this.onRender}
            >
                <Grid style={{height:'100%',overflowX:'hidden'}} justify="center" alignItems="center" container xs={12} sm={12} md={12} lg={12} xl={12}  >
                    <Grid item container xs={12} sm={6} md={6} lg={6} xl={4} >
                        <Paper style={{ height: '100%', width: '100%', padding: 20 }}>
                            <Grid container style={{ height: '100%', width: '100%' }}>
                                <Grid style={{ height: '10%' }} item container xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography variant="title" id="modal-title">
                                        {this.props.modal.id === 'new' ? "Novo Tipo de Aeronave" : "Editar Tipo de Aeronave"}
                                    </Typography>
                                </Grid>
                                <Grid style={{ height: '25%' }} item container xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography style={{ marginTop: 14, marginRight: 10 }} variant="subheading" id="modal-title">
                                        Ativo:
                                    </Typography>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                id='active'
                                                value='active'
                                                checked={this.state.type.active}
                                                onChange={event => {
                                                    let { type } = this.state;
                                                    this.setState({ type: { ...type, active: event.target.checked } })
                                                }}
                                                color="primary"
                                            />
                                        }
                                    />
                                </Grid>
                                <Grid item container xs={12} sm={12} md={12} lg={12} xl={12} spacing={16} style={{ height: '30%', padding: 0, margin: 0, marginBottom: 10 }}>
                                    <TextField
                                        id="name"
                                        required
                                        label="Nome do Tipo de Aeronave"
                                        style={{ width: '100%', margin: 10 }}
                                        value={this.state.type.type}
                                        onChange={event => {
                                            let { type } = this.state;
                                            this.setState({ type: { ...type, type: event.target.value } })
                                        }}
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item justify='flex-end' container style={{ height: '10%', margin: 20 }} xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button
                                        color="primary"
                                        onClick={() => {
                                            if(this.state.type.type !== '')
                                                this.props.handleSave(this.state.type)
                                            else
                                                this.props.msgSimple('Preencha os campos obrigatórios.')
                                        }}
                                    >
                                        Salvar
                                    </Button>
                                    <Button
                                        color="secondary"
                                        onClick={() => this.props.func()}
                                    >
                                        Cancelar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
    msgSimple
};

export default connect( mapStateToProps, mapDispatchToProps)(ModalAircraftType)



// WEBPACK FOOTER //
// ./src/routes/settings/aircraft-type/Modal.js